import { cx } from "@emotion/css";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import useKeypress from "react-use-keypress";
import { MobileTopBar } from "src/components/GlobalSearch/MobileTopBar";
import Notifications from "src/components/GlobalSearch/Notifications";
import { PesInfo } from "src/components/GlobalSearch/PesInfo";
import { ProfilePopup } from "src/components/GlobalSearch/Profile/ProfilePopup";
import { isMac } from "src/components/GlobalSearch/SearchInput";
import { Settings } from "src/components/GlobalSearch/Settings/Settings";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import isMobile from "src/helpers/isMobile";

type GlobalSearchProps = {
	className?: string;
};

export function GlobalSearch(props: GlobalSearchProps) {
	const { t } = useTranslation();
	const { openModal } = useModals();

	const openSearch = () => openModal(ModalsNames.GlobalSearchModal);

	useKeypress(["k", "K"], (event: KeyboardEvent) => {
		if (!(event.metaKey || event.ctrlKey)) return;
		event.preventDefault();
		openSearch();
	});

	return (
		<div className={cx("main-app-search-container", props.className)}>
			<div className="flex-1 min-w-0">
				<button
					type="button"
					onClick={openSearch}
					className="search-input search-input--trigger"
					data-test-id="global-search-trigger"
				>
					<Search className="search-input__icon icon-small" />
					<span className="search-input__placeholder text-ellipsis-1">
						{t("globalSearch.placeholder", "Szukaj pytań, artykułów, fiszek…")}
					</span>
					{!isMobile() && (
						<span className="search-input__hint">
							<kbd>{isMac ? "⌘" : "Ctrl"}</kbd>
							<kbd>K</kbd>
						</span>
					)}
				</button>
			</div>
			{isMobile() ? (
				<MobileTopBar />
			) : (
				<div className="flex items-center justify-end gap-8 mx-8 h-48">
					<PesInfo />
					<Settings />
					<Notifications />
					<ProfilePopup />
				</div>
			)}
		</div>
	);
}
